import './App.css';
import ComplexNavbar from './resources/navbar.js'
import Footer from './resources/Footer.js'
import Loader from './components/Loader/Loader.js';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Home from './components/Home.js';
import Profile from "./components/Profile.js";
import PrivacyPolicy from "./components/Privacy_policy.js";
import Login from "./components/User_Auth/Login";
import BidHistory from "./components/Bid.js";
import AccountHistory from './components/Ac_statement.js';
import SignupPage from './components/User_Auth/Singn_up.js';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector,useDispatch } from 'react-redux';
import ProtectedRoute from "./ProtectedRoute";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer } from 'react-toastify';
import { toastCss } from './constant/constant.js';
import { toast} from 'react-toastify';
import HowToPlay from "./components/How_to_play.js";
import GameRates from './components/Game_rule.js';
import { get_all_depends,clearmsg_promt,logged_user_storage,setFcmToken } from './features/userSlice.js';
import MyComponent from './components/Game_type.js';
import PaymentComponent from './components/payment/Add_payment.js';
import Withdrawal from './components/wallet/Wth.js';
import SangamComponent from './components/SangamComponent.js';
import PlayComponent from './components/Play_Component.js';
import RequestHistory from './components/History.js';
import LotusMatka from './components/Download_Applocation.js';
import MpinForm from './components/User_Auth/Mpin.js';
import OtpForm from './components/User_Auth/Otp.js';
import LoginMpin from './components/User_Auth/Login_mpin.js';
import AllBids from './components/All_Bids.js';
import ChartCompo from './components/ChartCompo.js';
import WalletMethod from './components/WalletMethod.js';
import AddFUnAuto from './components/wallet/AddFUnAuto.js';
import AddBankDetails from './components/wallet/AddBankDetails.js';
import FundsHistory from './components/wallet/FundsHistory.js';
import AddFundManual from './components/wallet/AddFundManual.js';
import SingleGame from './components/SInglegame.js';
import PaymentStatus from './components/wallet/Payment_status.js';
import LoadingComponent from './components/Loader/Lodind_compo.js';
import './brand.css';
import './components/screens.css';
import { translate } from './i18n';

// One pop-up at a time: while it is still showing, repeat messages are dropped
const APP_TOAST_ID = 'app-toast';
const showToast = (type, msg) => {
  if (toast.isActive(APP_TOAST_ID)) return;
  toast[type](translate(msg), { ...toastCss, toastId: APP_TOAST_ID });
};
// Define a custom hook that calls the function after each route change
function useRouteChangeCallback(callback) {
  const location = useLocation(); 
  useEffect(() => {
    callback(location); // Call the callback whenever the location changes
  }, [location, callback]);
}

function MyComponents() {
  const dispatch=useDispatch();
 const navigate = useNavigate();
 const location = useLocation();
  const lastSegment = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
    const { loading,isUserLogedIn,Info } = useSelector((state) => state.users);
    const [locationCurrent,setCurrentLocation]=useState('');
    useEffect(()=>{
      if (isUserLogedIn && ['login','sign-up','M_pin','otp','login_mpin'].includes(lastSegment)) {
          navigate("/");
  }
  
  },[isUserLogedIn, lastSegment, navigate])
  
  useRouteChangeCallback((location) => {
     setCurrentLocation(location?.pathname);
    if(loading===false && isUserLogedIn && Info?.phone_number && location?.pathname!==locationCurrent){
      let data = new FormData();
      data.append('phone_number',Info?.phone_number);
      dispatch(get_all_depends({request_type:'fetch_pofile',data}));  
    }
    
  });
}

 function App () {
  const { loading,error,successMsg,isUserLogedIn,Info } = useSelector((state) => state.users);
  const dispatch=useDispatch();
  const [isLoading_compo,seisLoadingCompo]=useState(true);

  const touchStartY = useRef(0);
  const touchEndY = useRef(0);
  const holdTimer = useRef(null);
  const isHolding = useRef(false);
  const queryParams = new URLSearchParams(window.location.search);
  const [isTokenSet,setIsTOken]=useState(false);
  const fcmtoken = queryParams.get("fcm_token") || false;
  // Function to check if the user is at the top of the page
  const isAtTopOfPage = () => window.scrollY === 0;

  // Handle touch start (user presses down)
  const handleTouchStart = (e) => {
    touchStartY.current = e.touches[0].clientY;

    if (isAtTopOfPage()) {
      holdTimer.current = setTimeout(() => {
        isHolding.current = true;
      }, 100); // Long press threshold (900ms)
    }
  };

  // Handle touch move (user swipes)
  const handleTouchMove = (e) => {
    touchEndY.current = e.touches[0].clientY;
  };

  // Handle touch end (user lifts finger)
  const handleTouchEnd = () => {
    clearTimeout(holdTimer.current); // Clear hold timer

    if (
      isHolding.current &&
      touchEndY.current > touchStartY.current + 50 && // Detect swipe down (50px threshold)
      isAtTopOfPage()
    ) {
      let data = new FormData();
      data.append('phone_number',Info?.phone_number);
      dispatch(get_all_depends({request_type:'fetch_pofile',data})); 
      dispatch(get_all_depends({request_type:'get_games',data:data}));
      dispatch(get_all_depends({request_type:'get_rates',data:data}));  
    } 
    isHolding.current = false; // Reset hold flag
  };

  useEffect(()=>{
    const user_session = localStorage.getItem('user_session');
    const userObject = JSON.parse(user_session);
    if(userObject?.phone_number){
              dispatch(logged_user_storage(userObject));

    }
   },[dispatch])

  // Splash calls this once its intro animation has finished
  const hideSplash = useCallback(() => seisLoadingCompo(false), []);

useEffect(()=>{
    if(fcmtoken){
         localStorage.setItem("fcm_token",fcmtoken);
    }
     const token = localStorage.getItem("fcm_token") || fcmtoken;
    if(Info?.phone_number && !isTokenSet && token){
           let data = new FormData();
          data.append('phone_number',Info?.phone_number);
          data.append('fcm_token',token);
          data.append('status',Info?.status);
          dispatch(setFcmToken(data));
          setIsTOken(true);
    }
   },[dispatch,fcmtoken,Info,isTokenSet])

  useEffect(()=>{
    if(error){
           showToast('success',error);
           dispatch(clearmsg_promt({error:false}));
    }
   },[dispatch,error])
   useEffect(()=>{
    if(successMsg){
           showToast('error',successMsg);
           dispatch(clearmsg_promt({error:true}));
    }
   },[dispatch,successMsg])

   useEffect(()=>{
    if(isUserLogedIn){
          let data = new FormData();
          data.append('phone_number',Info?.phone_number);
          dispatch(get_all_depends({request_type:'get_games',data:data}));
          dispatch(get_all_depends({request_type:'get_rates',data:data}));  
    }
   },[dispatch,isUserLogedIn,Info?.phone_number])
   

  return (
    <div className="App"
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
    onTouchEnd={handleTouchEnd}
    >
      <ToastContainer/>
      {(isLoading_compo)?
      <LoadingComponent onDone={hideSplash}/>:''}
     <Router>
     {isUserLogedIn?<ComplexNavbar/>:''}
     {isUserLogedIn && <div className="app-nav-spacer" aria-hidden="true" />}
     <Loader isLoading={loading && !isLoading_compo} />
     <MyComponents />


            <Routes>
                          <Route path="/home" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:true}}>
                          <Home />
                          </ProtectedRoute>
                          } />

                          <Route path="/" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:true}}>
                          <Home />
                          </ProtectedRoute>
                          } />

                        
                         <Route path="/Login" element={<Login />} />
                         <Route path="/sign-up" element={<SignupPage />} />
                         <Route path="/M_pin" element={<MpinForm />} />
                         <Route path="/Otp" element={<OtpForm />} />
                         <Route path="/login_mpin" element={<LoginMpin />} />
                         
                           <Route path="/download-now" element={<LotusMatka/>}/>
                         <Route path="/profile" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <Profile />
                          </ProtectedRoute>
                          } />
                         
                          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                          <Route path="/how-to-play" element={<HowToPlay />} />

                          <Route path="/payment-status" getpay={true} element={<PaymentStatus/>} />

                          <Route path="/game-rates" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <GameRates />
                          </ProtectedRoute>
                          } />
                          <Route path="/my-bid" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <BidHistory />
                          </ProtectedRoute>
                          } />

                            <Route path="/all-bid" element={
                            <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                            <AllBids />
                            </ProtectedRoute>
                            } />

                          <Route path="/account-statement" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AccountHistory />
                          </ProtectedRoute>
                          } />
                          <Route path="/game_type/:gameName" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <MyComponent />
                          </ProtectedRoute>
                          } />

                          <Route path="/:chart_ype/:gameName" element={
                          <ProtectedRoute isAuthenticated={{logged_in:true,bettingOn:'1',isHome:false}}>
                          <ChartCompo />
                          </ProtectedRoute>
                          } />


                          <Route path="/game_type/:gameName/:gameType" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <PlayComponent />
                          </ProtectedRoute>
                          } />

                        <Route path="/game_type_single/:gameName/:gameType" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                        <SingleGame/>
                        </ProtectedRoute>
                        } />

                          <Route path="/game_type/:gameName/half_sangam" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <SangamComponent />
                          </ProtectedRoute>
                          } />
                          <Route path="/game_type/:gameName/full_sangam" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <SangamComponent />
                          </ProtectedRoute>
                          } />
                          <Route path="/deposit" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <PaymentComponent />
                          </ProtectedRoute>
                          } />
                           <Route path="/withdraw" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <Withdrawal />
                          </ProtectedRoute>
                          } />   

                        <Route path="/wallet_histroy" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <WalletMethod/>
                        </ProtectedRoute>
                        } />   
                        <Route path="/add_fund_auto" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AddFUnAuto/>
                        </ProtectedRoute>
                        } />   

                      <Route path="/add_fund_user" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AddFundManual/>
                        </ProtectedRoute>
                        } />   


                        <Route path="/add_bank_details" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <AddBankDetails/>
                        </ProtectedRoute>
                        } />  

                         <Route path="/fund_histry/:TYPE" element={
                        <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <FundsHistory/>
                        </ProtectedRoute>
                        } />  




                          
                          <Route path="/request_history" element={
                          <ProtectedRoute isAuthenticated={{logged_in:isUserLogedIn,bettingOn:Info?.status,isHome:false}}>
                          <RequestHistory />
                          </ProtectedRoute>
                          } />     
                         
                         
            </Routes>

            {(isUserLogedIn && Info?.status==='1')?<><div className="app-footer-spacer" aria-hidden="true" /><Footer/></>:''}                  

      </Router>
    </div>

  );

}

export default App;
